import DotDigits from './DotDigits';

export default DotDigits;
